export default "__VITE_ASSET__f2e50503__"